import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttackSurfacePDF from "./PDFReports/AttackSurfacePDF";
import DNSPDF from "./PDFReports/DNSReportPDF";
import SSLPDF from "./PDFReports/SSLReportPDF";
import MailServerPDF from "./PDFReports/MailServerPDF";
import CookieScanPDF from "./PDFReports/CookieScanReportPDF";
import PentestPDF from "./PDFReports/PentestReportPDF";
import PrivacyPolicyPDF from "./PDFReports/PrivacyPolicyPDF";
import BlacklistPDF from "./PDFReports/BlacklistResultsPDF";

// ✅ Mapping for PDF components
const reportComponents = {
  dnscheck: DNSPDF,
  sslcheck: SSLPDF,
  mailservercheck: MailServerPDF,
  cookiescanner: CookieScanPDF,
  pentester: PentestPDF,
  attacksurfacemapper: AttackSurfacePDF,
  privacypolicycheck: PrivacyPolicyPDF,
  gdprcheck: PrivacyPolicyPDF,
  toscheck: PrivacyPolicyPDF,
  blacklistcheck: BlacklistPDF,
};

const DownloadPDFButton = ({ type, data, pageTitle }) => {
  const ReportComponent = reportComponents[type];

  if (!ReportComponent) return null; // If the report type is not available, return nothing

  return (
    <PDFDownloadLink document={<ReportComponent data={data} pageTitle={pageTitle}/>} fileName={`${pageTitle?.replace(/ /g,"_")}- Portend AI.pdf`}>
      {({ loading }) => (
        <button style={{ padding: "10px 15px", background: "rgb(0, 145, 70)", color: "white", border: "none", borderRadius: "5px" }}>
          {loading ? "Generating PDF..." : "Download PDF"}
        </button>
      )}
    </PDFDownloadLink>
  );
};

export default DownloadPDFButton;
